import { z } from 'zod'

import type {
  CartItemCreationResponse,
  CartItemUpdateResponse,
  CartItemWithDeliveryAmountResponse,
  CommonCloudFrontUrlResponse,
} from '~/api-spec/__generated__/pod'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type Cart,
  type CartItem,
  type CartItemPrice,
  CartItemPriceSchema,
  CartSchema,
  type PdfDownload,
  PdfDownloadSchema,
} from './schemas'

const ENTITY = 'PodCart'

// 생성 타입과 실제 와이어가 어긋나는 필드. 2026-10-06 POD 서버 develop(edfdcec) 코드로 확인:
//   coverData — 서버 CoverData.kt 의 customData 는 ArrayNode(JSON 배열)인데 스펙은 object 로 그리고,
//     ObjectNode? 칸(subtitle 등)과 맞춤 교재의 coverData 를 키째 null 로 싣는데 스펙은 optional 로만 그린다
//   workbookParts·parentOrders·semester — Kotlin nullable 을 키째 null 로 싣는데 스펙은 optional 로만 그린다
// 스키마가 실제 와이어를 검증하므로 입력을 이 한 자리에서 unknown 으로 넘긴다.
const asWire = (raw: CartItemWithDeliveryAmountResponse): unknown => raw

export const adaptCart = (raw: CartItemWithDeliveryAmountResponse): Cart =>
  parseApiResponse(CartSchema, asWire(raw), ENTITY)

const _CartItemCreationSchema = z.object({ id: z.number() })

export const adaptCartItemCreation = (raw: CartItemCreationResponse): CartItem['id'] =>
  parseApiResponse(_CartItemCreationSchema, raw, ENTITY).id

export const adaptCartItemPrice = (raw: CartItemUpdateResponse): CartItemPrice =>
  parseApiResponse(CartItemPriceSchema, raw, ENTITY)

export const adaptPdfDownload = (raw: CommonCloudFrontUrlResponse): PdfDownload =>
  parseApiResponse(PdfDownloadSchema, raw, ENTITY)
